import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const COMPLIANCE_PERMISSIONS = {
  POLICY_FILE_CREATE: 'compliance.policy_file:create',
  POLICY_FILE_READ: 'compliance.policy_file:read',
  POLICY_FILE_UPDATE: 'compliance.policy_file:update',

  PROJECT_STATUS_READ: 'compliance.project_status:read',
  PROJECT_STATUS_UPDATE: 'compliance.project_status:update',

  PROMOTION_MATERIAL_CREATE: 'compliance.promotion_material:create',
  PROMOTION_MATERIAL_READ: 'compliance.promotion_material:read',
  PROMOTION_MATERIAL_SUBMIT: 'compliance.promotion_material:submit',
  PROMOTION_MATERIAL_WITHDRAW: 'compliance.promotion_material:withdraw',

  PROMOTION_REVIEW_READ: 'compliance.promotion_review:read',
  PROMOTION_REVIEW_APPROVE: 'compliance.promotion_review:approve',

  SENSITIVE_TERM_CREATE: 'compliance.sensitive_term:create',
  SENSITIVE_TERM_READ: 'compliance.sensitive_term:read',
  SENSITIVE_TERM_UPDATE: 'compliance.sensitive_term:update',

  RECHECK_TASK_READ: 'compliance.recheck_task:read',
  RECHECK_TASK_ASSIGN: 'compliance.recheck_task:assign',
  RECHECK_TASK_RESOLVE: 'compliance.recheck_task:resolve',
  RECHECK_TASK_CANCEL: 'compliance.recheck_task:cancel',
} as const;

export type CompliancePermission =
  (typeof COMPLIANCE_PERMISSIONS)[keyof typeof COMPLIANCE_PERMISSIONS];

export function canSeeComplianceMenu(granted: readonly string[]): boolean {
  return hasAnyPermission(granted, [
    COMPLIANCE_PERMISSIONS.POLICY_FILE_READ,
    COMPLIANCE_PERMISSIONS.PROJECT_STATUS_READ,
    COMPLIANCE_PERMISSIONS.PROMOTION_MATERIAL_READ,
    COMPLIANCE_PERMISSIONS.PROMOTION_REVIEW_READ,
    COMPLIANCE_PERMISSIONS.SENSITIVE_TERM_READ,
    COMPLIANCE_PERMISSIONS.RECHECK_TASK_READ,
  ]);
}
